import React from "react";
import get from "lodash/get";
import find from "lodash/find";
import classnames from "classnames";
import { connect } from "react-redux";
import {
  Alert,
  Icon,
  Layout,
  List,
  Badge,
  Button,
  Switch,
  message,
  Row,
  Col,
  Breadcrumb,
} from "antd";

import AdminHeader from "../../components/AdminHeader/AdminHeader";
import SettingsUserRoleForm from "../../components/SettingsUserRoleForm/SettingsUserRoleForm";
import Footer from "../../components/Footer/Footer";

import isAuthenticated from "../../utils/isAuthenticated";
import {
  getSettingsRolesRequest,
  getSettingsUserSingleRequest,
  getSettingsSitesRequest,
  getPermissionsStructureRequest,
} from "../../api/requests";
import { logout, setPermissions } from "../../reducers/user/actions";
import {
  getRoleCreatePermission,
  getUserToken,
} from "../../reducers/user/selectors";

import classes from "./SettingsUserRoles.css";
import { withNamespaces } from "react-i18next";
import forEach from "lodash/forEach";

const routes = require("../../routes.json");

const { Content } = Layout;

class SettingsUserRoles extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      rolesList: [],
      sitesList: [],
      permissionsStructure: [],
      permissionsStructureKeys: {},
      errorMessage: "",
      responseMessage: "",
      roleEdit: null,
      selectedRole: null,
      user: {},
      isLoading: true,
    };
  }

  async componentDidMount() {
    this.setState({
      errorMessage: null,
      isLoading: true,
      responseMessage: null,
    });

    await Promise.all([
      this.getUser(),
      this.getRolesList(),
      this.getSitesList(),
      this.getPermissionsStructure(),
    ]);

    this.setState({ isLoading: false });
  }

  getUser = async () => {
    try {
      const { data } = await getSettingsUserSingleRequest(
        get(this.props, "match.params.userID")
      );
      this.setState({ user: data });
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      this.setState({
        subject: null,
        errorMessage: get(e, "response.data.error", "Error"),
      });
    }
  };

  getSitesList = async () => {
    try {
      const { data } = await getSettingsSitesRequest();
      this.setState({ sitesList: data });
    } catch (e) {
      if (e.response.status === 401) {
        this.props.logout();
        return;
      }
      console.log(e);
    }
  };

  getRolesList = async () => {
    try {
      const { data } = await getSettingsRolesRequest();
      this.setState({ rolesList: data });
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      this.setState({
        subject: null,
        errorMessage: get(e, "response.data.error", "Error"),
      });
    }
  };

  onSelectRole = (role) => () => {
    this.setState({ selectedRole: null }, () => {
      this.setState({ selectedRole: role });
    });
  };

  onRoleEditHide = () => {
    this.setState({ selectedRole: null });
  };

  onRoleEditSubmit = async (roleID) => {
    this.props.setPermissions(this.props.userToken);
    await this.getUser();

    this.setState({ selectedRole: null }, () => {
      this.setState({
        selectedRole: find(
          get(this.state.user, "site_access_list", []),
          (roleItem) => roleItem.id === roleID
        ),
      });
    });
  };

  onAddRole = () => {
    this.setState({ selectedRole: null }, () => {
      this.setState({ selectedRole: {} });
    });
  };

  getPermissionsStructure = async () => {
    try {
      const { data } = await getPermissionsStructureRequest();

      const permissionsStructure = {};
      const permissionsStructureKeys = {};

      forEach(data, (item) => {
        const permissionItem = {};
        const permissions = [...item.permissions];
        const selectType = {};
        const checkboxType = [];

        permissions.forEach(({ id, key, value, type, message, group }) => {
          permissionsStructureKeys[key] = `${id}`;

          if (group) {
            selectType[`group_${group.id}`] = selectType[`group_${group.id}`]
              ? [
                  ...selectType[`group_${group.id}`],
                  { key: `${id}`, value, name: group.name },
                ]
              : [{ key: `${id}`, value, name: group.name }];
          } else {
            checkboxType.push({
              key: `${id}`,
              name: value,
              label: message ? { type, message } : null,
            });
          }
        });

        permissionItem.name = item.value;
        permissionItem.fields = [
          ...Object.keys(selectType).map((key) => ({
            key,
            name: get(selectType, `${key}[0].name`),
            permissions: selectType[key],
          })),
        ];

        if (checkboxType.length > 0) {
          permissionItem.fields = [...permissionItem.fields, ...checkboxType];
        }

        permissionsStructure[item.id] = permissionItem;
      });

      this.setState({ permissionsStructure, permissionsStructureKeys });
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      this.setState({
        subject: null,
        errorMessage: get(e, "response.data.error", "Error"),
      });
    }
  };

  render() {
    const {
      rolesList,
      sitesList,
      errorMessage,
      responseMessage,
      isLoading,
      selectedRole,
      user,
      permissionsStructure,
      permissionsStructureKeys,
    } = this.state;
    const { roleCreatePermission } = this.props;

    return (
      <div style={{ backgroundColor: "#FAFAFA" }}>
        <Layout className={classes.parentContainer}>
          <Content className={classes.content}>
            <h3 className="headline-default">
              {this.props.i18n.t("NamespaceSettingsUserRoles:User roles for")}{" "}
              {get(user, "username", <Icon type="loading" />)}
            </h3>

            <Breadcrumb>
              <Breadcrumb.Item href="/admin/settings">
                {this.props.i18n.t("Admin Settings")}
              </Breadcrumb.Item>
              <Breadcrumb.Item href="/admin/settings/users">
                {this.props.i18n.t("User Management")}
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                {this.props.i18n.t("User Role Management")}
              </Breadcrumb.Item>
            </Breadcrumb>
            <br />

            {isLoading && <Icon type="loading" />}

            {!isLoading && (
              <Row gutter={24}>
                {roleCreatePermission && (
                  <div className={classes.roleActionWrapper}>
                    <Button type="primary" onClick={this.onAddRole}>
                      {this.props.i18n.t("Add role")}
                    </Button>
                  </div>
                )}
                <Col lg={6}>
                  <p>
                    <b>
                      {this.props.i18n.t(
                        "NamespaceSettingsUserRoles:Select a site and role to edit"
                      )}
                    </b>
                  </p>

                  <List
                    className={classes.rolesList}
                    bordered
                    dataSource={get(user, "site_access_list", []).sort(
                      (a, b) => get(a, "site.code") - get(b, "site.code")
                    )}
                    renderItem={(item) => (
                      <List.Item
                        className={classnames(classes.roleItem, {
                          [classes.active]: item.id === get(selectedRole, "id"),
                        })}
                        onClick={this.onSelectRole(item)}
                      >
                        {get(item, "site.code")} - {get(item, "site.name")} -{" "}
                        {get(item, "user_role.name")}
                        <Badge
                          count={item.state}
                          style={{
                            backgroundColor:
                              item.state === "active" ? "#49c850" : "#f00",
                          }}
                        />
                      </List.Item>
                    )}
                  />
                </Col>

                <Col lg={18}>
                  <p>&nbsp;</p>

                  {selectedRole && (
                    <SettingsUserRoleForm
                      selectedRole={selectedRole}
                      userID={get(user, "id")}
                      isNew={selectedRole && !selectedRole.id}
                      onSubmit={this.onRoleEditSubmit}
                      onCancel={this.onRoleEditHide}
                      rolesList={rolesList}
                      sitesList={sitesList}
                      permissionsStructureKeys={permissionsStructureKeys}
                      permissionsStructure={permissionsStructure}
                    />
                  )}
                </Col>
              </Row>
            )}

            {errorMessage && <Alert type="error" message={errorMessage} />}

            {responseMessage && (
              <Alert type="success" message={responseMessage} />
            )}
          </Content>
        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  roleCreatePermission: getRoleCreatePermission(state),
  userToken: getUserToken(state),
});

const mapDispatchToProps = { logout, setPermissions };

export default isAuthenticated(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withNamespaces()(SettingsUserRoles))
);



// WEBPACK FOOTER //
// ./src/containers/SettingsUserRoles/SettingsUserRoles.js